export class CardBackgroundImageAction {
  static readonly type = '[Card Background Image] CardBackgroundImageAction';
  constructor(public nestedConfigKey: string) {}
}

export class CardBackgroundImageSelected {
  static readonly type = '[Card Background Image] CardBackgroundImageSelected';
  constructor(public src: string, public nestedConfigKey: string) {}
}

export class CardFlipIconAction {
  static readonly type = '[Card Flip Icon] CardFlipIconAction';
  constructor() {}
}

export class CardFlipIconSelected {
  static readonly type = '[Card Flip Icon] CardFlipIconSelected';
  constructor(public src: string) {}
}
